import { requests } from '../index';
import URLS  from '../endPoints';
import request from 'superagent';

import axios from "axios"

let Home = {}
//MG Api
Home.uploadAppResumeMg = async (payload) => await requests.post(URLS.magUrl.uploadAppResumeMg, payload);


//HC master APi
Home.countryMaster = async () => await requests.getHCMaster(URLS.hcMaster.countryMaster) //api call
Home.stateMaster = async (cId) => await requests.getHCMaster(URLS.hcMaster.stateMaster+cId) //api call
Home.cityMaster = async (sId) => await requests.getHCMaster(URLS.hcMaster.cityMaster+sId) //api call
Home.degreeMaster = async () => await requests.getHCMaster(URLS.hcMaster.degreeMaster) //api call
Home.degreeMasterFiltered = async (id) => await requests.getHC(URLS.hcUrl.getEducationType+id) //api call
Home.universityMaster = async () => await requests.getHCMaster(URLS.hcMaster.universityMaster) //api call
Home.collegeMaster = async () => await requests.getHCMaster(URLS.hcMaster.collegeMaster) //api call
Home.specializationMaster = async () => await requests.getHCMaster(URLS.hcMaster.specializationMaster) //api call
Home.designation = async () => await requests.getHCMaster(URLS.hcMaster.designation) //api call
Home.currency = async () => await requests.getHCMaster(URLS.hcMaster.currency) //api call
Home.department = async () => await requests.getHCMaster(URLS.hcMaster.department) //api call
Home.emptype = async () => await requests.getHCMaster(URLS.hcMaster.emptype) //api call
Home.language = async () => await requests.getHCMaster(URLS.hcMaster.language) //api call
Home.industry = async () => await requests.getHCMaster(URLS.hcMaster.industry) //api call
Home.educationgroup = async () => await requests.getHCMaster(URLS.hcMaster.educationgroup) //api call

// HC Profile Get Apis
Home.getBasic = async (CANID) => await requests.getHC(URLS.hcUrl.getBasic+CANID) //api call
Home.getContact = async (CANID) => await requests.getHC(URLS.hcUrl.getContact+CANID) //api call
Home.getEducation = async (CANID) => await requests.getHC(URLS.hcUrl.getEducation+CANID) //api call
Home.getEmployee = async (CANID) => await requests.getHC(URLS.hcUrl.getEmployee+CANID) //api call
Home.getlanguage = async (CANID) => await requests.getHC(URLS.hcUrl.getlanguage+CANID) //api call
Home.Rating=async()=>await requests.getHCMaster(URLS.hcMaster.Rating) //api call
Home.skill=async()=>await requests.getHCMaster(URLS.hcMaster.skill) //api call
Home.getSkill = async (CANID) => await requests.getHC(URLS.hcUrl.getSkill+CANID) //api call
Home.getCertification = async (CANID) => await requests.getHC(URLS.hcUrl.getCertification+CANID) //api call
Home.getPublication = async (CANID) => await requests.getHC(URLS.hcUrl.getPublication+CANID) //api call

// HC Profile POST Apis
Home.postBasic = async (payload) => await requests.postHC(URLS.hcUrl.resumeSaving,payload) //api call
Home.updateBasicDetails = async (payload) => await requests.postHC(URLS.hcUrl.updateBasicDetails,payload) //api call
Home.saveContactInfo = async (payload) => await requests.postHC(URLS.hcUrl.saveContactInfo,payload) //api call
Home.uploadResume = async (payload) => await requests.postHC(URLS.hcUrl.uploadResume,payload) //api call
Home.saveAcademicInfo = async (payload) => await requests.postHC(URLS.hcUrl.saveAcademicInfo,payload) //api call
Home.saveWorkExperience = async (payload) => await requests.postHC(URLS.hcUrl.saveWorkExperience,payload) //api call
Home.saveLanguageInfo = async (payload) => await requests.postHC(URLS.hcUrl.saveLanguageInfo,payload) //api call
Home.saveSkill = async (payload) => await requests.postHC(URLS.hcUrl.saveSkill,payload) //api call
Home.saveCertification = async (payload) => await requests.postHC(URLS.hcUrl.saveCertification,payload) //api call
Home.savePublication = async (payload) => await requests.postHC(URLS.hcUrl.savePublication,payload) //api call

// myjobs section

//Resume
Home.geResumeHC = async (CANID) => await requests.getHC(URLS.hcUrl.geResumeHC+CANID) //api call
Home.uploadResume = async (CANID) => await requests.postHC(URLS.hcUrl.uploadResume,CANID) //api call

// Profile Pic
Home.updateUserProfile = async (CANID) => await requests.post(URLS.magUrl.updateUserProfile,CANID) //api call
Home.upploadDocument= async (CANID) => await requests.postHC(URLS.hcUrl.upploadDocument,CANID) //api call

// Job history
Home.getApplicantHistory = async (CANID) => await requests.getHC(URLS.hcUrl.getApplicantHistory+CANID) //api call
// https://clg.icicibank.com/Hc_IbankApi/Career/getApplicantHistory/{ReqResID:long}

//Career/ParseResume

Home.parseResume = async (CANID) => await requests.postHC(URLS.hcUrl.parseResume,CANID) //api call


export default Home;
